"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var environmentGuardPlugin_exports = {};
__export(environmentGuardPlugin_exports, {
  environmentGuardPlugin: () => environmentGuardPlugin,
  loadEnvironmentGuard: () => loadEnvironmentGuard,
  resolveEnvironmentGuard: () => resolveEnvironmentGuard
});
module.exports = __toCommonJS(environmentGuardPlugin_exports);
var import_filter = require("rolldown/filter");
var VIRTUAL_PREFIX = "\0one-env-guard:";
var GUARD_SPECIFIERS = [
  "server-only",
  "client-only",
  "native-only",
  "web-only"
];
var GUARD_SPECIFIERS_RE = new RegExp(`^(?:${GUARD_SPECIFIERS.join("|")})$`);
var ALLOWED_BY_NAME = {
  "native-only": [
    "ios",
    "android"
  ],
  "web-only": [
    "client",
    "ssr",
    "worker"
  ]
};
var ALLOWED_BY_CONSUMER = {
  "server-only": "server",
  "client-only": "client"
};
function resolveEnvironmentGuard(specifier, envName, consumer, options) {
  var _options_disableGuards;
  if (!GUARD_SPECIFIERS.includes(specifier)) {
    return null;
  }
  if ((options === null || options === void 0 ? void 0 : options.disabled) || (options === null || options === void 0 ? void 0 : (_options_disableGuards = options.disableGuards) === null || _options_disableGuards === void 0 ? void 0 : _options_disableGuards.includes(specifier))) {
    return `${VIRTUAL_PREFIX}${specifier}:disabled`;
  }
  return `${VIRTUAL_PREFIX}${specifier}:${envName}:${consumer !== null && consumer !== void 0 ? consumer : "unknown"}`;
}
function loadEnvironmentGuard(id) {
  if (!id.startsWith(VIRTUAL_PREFIX)) {
    return null;
  }
  var rest = id.slice(VIRTUAL_PREFIX.length);
  var parts = rest.split(":");
  if (parts.length === 2 && parts[1] === "disabled") {
    return "export {}";
  }
  var specifier = parts[0];
  var envName = parts[1];
  var consumer = parts[2];
  var requiredConsumer = ALLOWED_BY_CONSUMER[specifier];
  if (requiredConsumer) {
    if (consumer === requiredConsumer) return "export {}";
    if (!consumer || consumer === "unknown") {
      var legacyAllowed = requiredConsumer === "server" ? [
        "ssr"
      ] : [
        "client"
      ];
      if (legacyAllowed.includes(envName)) return "export {}";
    }
    return `throw new Error("${specifier} cannot be imported in the \\"${envName}\\" environment")`;
  }
  var allowedNames = ALLOWED_BY_NAME[specifier];
  if (!allowedNames) return null;
  if (allowedNames.includes(envName)) return "export {}";
  return `throw new Error("${specifier} cannot be imported in the \\"${envName}\\" environment")`;
}
function environmentGuardPlugin(options) {
  return {
    name: "one:environment-guard",
    enforce: "pre",
    // filters are evaluated in rust, so non-guard ids never cross into js.
    // without them every import in the graph paid a napi round trip to be told
    // it wasn't one of these four specifiers.
    resolveId: {
      filter: {
        id: GUARD_SPECIFIERS_RE
      },
      handler(source) {
        var _this_environment, _this_environment_config, _this_environment1;
        var envName = (_this_environment = this.environment) === null || _this_environment === void 0 ? void 0 : _this_environment.name;
        if (!envName) return null;
        var consumer = (_this_environment1 = this.environment) === null || _this_environment1 === void 0 ? void 0 : (_this_environment_config = _this_environment1.config) === null || _this_environment_config === void 0 ? void 0 : _this_environment_config.consumer;
        return resolveEnvironmentGuard(source, envName, consumer, options);
      }
    },
    load: {
      filter: {
        id: (0, import_filter.prefixRegex)(VIRTUAL_PREFIX)
      },
      handler(id) {
        return loadEnvironmentGuard(id);
      }
    }
  };
}
//# sourceMappingURL=environmentGuardPlugin.js.map
